import { defineRecipe } from '@chakra-ui/react';

export const badgeRecipe = defineRecipe({
  base: {
    borderRadius: 'l1',
    justifyContent: 'center',
    fontWeight: '400',
    height: '26px',
  },
  variants: {
    colorPalette: {
      neutral: {
        bg: 'neutral.50',
        color: 'neutral.500',
      },
      orange: {
        bg: 'orange.50',
        color: 'orange.900',
      },
      red: {
        bg: 'red.50',
        color: 'red.900',
      },
      green: {
        bg: 'green.50',
        color: 'green.950',
      },
      success: {
        bg: 'neonGreen.50',
        color: 'brand.800',
      },
      blue: {
        bg: 'blue.50',
        color: 'blue.500',
      },
      partiallyApproved: {
        bg: 'unset',
        bgGradient: 'gradients.primary',
        color: 'neutral.500',
      },
      live: {
        bg: 'green.700',
        color: 'neutral.0',
        fontWeight: 'medium',
      },
      test: {
        bg: 'orange.600',
        color: 'neutral.0',
        fontWeight: 'medium',
      },
      current: {
        bg: 'brand.100',
        color: 'brand.600',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  } as any, // TODO: we need to wait for chakra-ui to fix typings here
});
